import { HttpLink } from "apollo-link-http";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { setContext } from "apollo-link-context";

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_URL_API_DLL,
});

const defaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore",
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  },
};

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = JSON.parse(localStorage.getItem("token"));
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      "auth-token": token ? token : "",
    },
  };
});

export default new ApolloClient({
  cache: new InMemoryCache(),
  defaultOptions: defaultOptions,
  link: authLink.concat(httpLink),
  request: (operation) => {
    const token = JSON.parse(localStorage.getItem("token"));
    operation.setContext({
      headers: {
        "auth-token": token ? token : "",
      },
    });
  },
});
